// FILE: src/hooks/useAccountManagerLimit.js
import { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc, collection, onSnapshot } from "firebase/firestore";
import { getAccountManagerLimit } from "../lib/planLimits";

/**
 * Assumes your Account Managers live under:
 *   users/{uid}/accountManagers
 * If your subcollection name is different, tell me and I'll adjust this file.
 */
export function useAccountManagerLimit(uid) {
  const [state, setState] = useState({
    loading: true,
    limit: 0,
    count: 0,
    remaining: 0,
  });

  useEffect(() => {
    if (!uid) return;
    let unsubscribe = () => {};

    (async () => {
      // Load user profile to read the plan
      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);
      const profile = userSnap.exists() ? userSnap.data() : {};
      const limit = getAccountManagerLimit(profile);

      // Live count of account managers
      const mgrCol = collection(db, "users", uid, "accountManagers");
      unsubscribe = onSnapshot(mgrCol, (qs) => {
        const count = qs.size;
        const remaining = Math.max(0, limit - count);
        setState({ loading: false, limit, count, remaining });
      });
    })();

    return () => unsubscribe();
  }, [uid]);

  return state; // { loading, limit, count, remaining }
}
